import { useEffect, useCallback } from 'react';

// Inject tracking scripts into head based on config pixel IDs
export function useTrackingPixels(config) {
  // Google Analytics
  useEffect(() => {
    const gaId = config?.gaId;
    if (!gaId || document.getElementById('ga-script')) return;
    const s1 = document.createElement('script');
    s1.id = 'ga-script';
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s1);
    const s2 = document.createElement('script');
    s2.id = 'ga-config';
    s2.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${gaId}');`;
    document.head.appendChild(s2);
  }, [config?.gaId]);

  // Meta Pixel
  useEffect(() => {
    const pixelId = config?.metaPixelId;
    if (!pixelId || document.getElementById('meta-pixel')) return;
    const s = document.createElement('script');
    s.id = 'meta-pixel';
    s.textContent = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${pixelId}');fbq('track','PageView');`;
    document.head.appendChild(s);
  }, [config?.metaPixelId]);

  // TikTok Pixel
  useEffect(() => {
    const pixelId = config?.tiktokPixelId;
    if (!pixelId || document.getElementById('tiktok-pixel')) return;
    const s = document.createElement('script');
    s.id = 'tiktok-pixel';
    s.textContent = `!function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=i;ttq._t=ttq._t||{};ttq._t[e]=+new Date;ttq._o=ttq._o||{};ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript";o.async=!0;o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};ttq.load('${pixelId}');ttq.page()}(window,document,'ttq');`;
    document.head.appendChild(s);
  }, [config?.tiktokPixelId]);

  const trackEvent = useCallback((eventName, data = {}) => {
    // Google Analytics
    if (config?.gaId && window.gtag) {
      if (eventName === 'purchase') {
        window.gtag('event', 'purchase', { value: data.value, currency: 'USD', transaction_id: data.ref });
      } else if (eventName === 'begin_checkout') {
        window.gtag('event', 'begin_checkout', { value: data.value, currency: 'USD' });
      } else if (eventName === 'add_to_cart') {
        window.gtag('event', 'add_to_cart', { value: data.value, currency: 'USD' });
      }
    }
    // Meta Pixel
    if (config?.metaPixelId && window.fbq) {
      if (eventName === 'purchase') {
        window.fbq('track', 'Purchase', { value: data.value, currency: 'USD' });
      } else if (eventName === 'begin_checkout') {
        window.fbq('track', 'InitiateCheckout', { value: data.value, currency: 'USD' });
      } else if (eventName === 'add_to_cart') {
        window.fbq('track', 'AddToCart', { value: data.value, currency: 'USD' });
      }
    }
    // TikTok
    if (config?.tiktokPixelId && window.ttq) {
      if (eventName === 'purchase') {
        window.ttq.track('CompletePayment', { value: data.value, currency: 'USD' });
      } else if (eventName === 'begin_checkout') {
        window.ttq.track('InitiateCheckout', { value: data.value, currency: 'USD' });
      } else if (eventName === 'add_to_cart') {
        window.ttq.track('AddToCart', { value: data.value, currency: 'USD' });
      }
    }
  }, [config?.gaId, config?.metaPixelId, config?.tiktokPixelId]);

  return { trackEvent };
}
